// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agents/catalogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsCatalogs } from "./constants";
import type { GenerativeAiAgentsCatalogsResult } from "./types";
import { isGenerativeAiAgentsCatalogsResult } from "./validators";

export const getGenerativeAiAgentsCatalogs = reactQueryFetcherAdapter(
  generativeAiAgentsCatalogs,
  (signal: AbortSignal): Promise<GenerativeAiAgentsCatalogsResult> => {
    return fetch("/generative_ai/agents/catalogs", "GET", {}, { signal });
  },
  isGenerativeAiAgentsCatalogsResult
);
